// Single source of truth for AOCEMS company contact information.
// Used across Contact page, Footer, and any other page referencing offices.

export const company = {
  brand: "AOCEMS",
  parent: "United Platform Solutions Global",
  domain: "Africaocems.com",
  email: {
    contact: "contact@africaocems.com",
    press: "press@africaocems.com",
  },
};

export const offices = [
  {
    code: "USA",
    label: "Head Office",
    country: "United States",
    flag: "🇺🇸",
    address: "806 East Palm Lane, Phoenix, AZ USA 85006",
    isHQ: true,
  },
  {
    code: "UAE",
    label: "Regional Office",
    country: "United Arab Emirates",
    flag: "🇦🇪",
    address: "Office C1-1F-SF0400, Ajman Free Zone, Ajman, UAE",
  },
  {
    code: "GHA",
    label: "Regional Office",
    country: "Ghana",
    flag: "🇬🇭",
    address: "Accra, Ghana",
  },
  {
    code: "KEN",
    label: "Regional Office",
    country: "Kenya",
    flag: "🇰🇪",
    address: "Nairobi, Kenya",
  },
  {
    code: "TZA",
    label: "Regional Office",
    country: "Tanzania",
    flag: "🇹🇿",
    address: "Dar es Salaam, Tanzania",
  },
];

export const phones = [
  { region: "Ghana", number: "+233 50 050 3599", tel: "+233500503599" },
  { region: "UAE", number: "+971 52 821 5799", tel: "+971528215799" },
  { region: "Global Desk", number: "+91 98732 42080", tel: "+919873242080" },
];
